import React from 'react';
import { Spinner } from '@/Components/shadcn';

const InfiniteScrollDefaultLoader = (): React.JSX.Element => {
    return (
        <div className="mt-4 flex justify-center">
            <Spinner className="text-primary size-8" />
        </div>
    );
};

export default InfiniteScrollDefaultLoader;
